import { api } from 'services/api';
import {
  ActivateDeviceParams,
  Device,
  IncomeDeviceParams,
  type UpdateDeviceMetersParams
} from 'types';

export const deviceApi = api
  .enhanceEndpoints({
    addTagTypes: ['Device', 'Devices', 'DeviceAuditLogs']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDevice: build.query<Device, string>({
        query: (id: string) => ({
          url: `/devices/${id}`,
          method: 'GET'
        }),
        providesTags: (res) =>
          res?.Id ? [{ type: 'Device', id: res?.Id }] : []
      }),
      updateDevice: build.mutation<void, Device>({
        query: (device: Device) => ({
          url: `/devices/${device.Id}`,
          method: 'POST',
          data: device
        }),
        invalidatesTags: (_res, _err, params) => [
          'Devices',
          { type: 'Device', id: params.Id }
        ]
      }),
      activateDevice: build.mutation<void, ActivateDeviceParams>({
        query: ({ deviceId, isActivated }) => ({
          url: `/devices/${deviceId}/activate`,
          method: 'POST',
          data: {
            IsActivated: isActivated
          }
        }),
        invalidatesTags: (_res, _err, params) => [
          'Devices',
          { type: 'Device', id: params.deviceId }
        ]
      }),
      deviceIncome: build.mutation<void, IncomeDeviceParams>({
        query: ({ deviceId, ...data }) => ({
          url: `/device/${deviceId}/income`,
          method: 'POST',
          data
        })
      }),
      updateDeviceMeters: build.mutation<void, UpdateDeviceMetersParams>({
        query: ({ deviceId, ...params }) => ({
          url: `/devices/${deviceId}/prepare/counter`,
          method: 'POST',
          data: params
        }),
        invalidatesTags: (_res, _err, params) => [
          'Devices',
          { type: 'Device', id: params.deviceId }
        ]
      })
    })
  });

export const {
  useUpdateDeviceMutation,
  useGetDeviceQuery,
  useActivateDeviceMutation,
  useDeviceIncomeMutation,
  useUpdateDeviceMetersMutation
} = deviceApi;
